var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import scheduleApiClient from '@/plugins/apis/v2/schedule-api-client';
import { ScheduleMutationTypes } from '@/types/schedule';
var DEFAULT_DEBOUNCE_MS = 150;
var debounceTimer = null;
var requestToken = 0;
var pendingProjectId = null;
export var emptyPublishStatus = {
    publish_changed: false,
    has_published_schedule: false
};
function fetchAndCommitPublishStatus(commit, projectId) {
    return __awaiter(this, void 0, Promise, function () {
        var currentToken, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    currentToken = ++requestToken;
                    return [4 /*yield*/, scheduleApiClient.fetchPublishStatus(projectId)];
                case 1:
                    data = (_a.sent()).data;
                    if (currentToken !== requestToken) {
                        return [2 /*return*/];
                    }
                    commit(ScheduleMutationTypes.SET_PUBLISH_STATUS, data);
                    return [2 /*return*/];
            }
        });
    });
}
export function resetPublishStatus(commit) {
    if (debounceTimer) {
        clearTimeout(debounceTimer);
        debounceTimer = null;
    }
    pendingProjectId = null;
    requestToken += 1;
    commit(ScheduleMutationTypes.SET_PUBLISH_STATUS, emptyPublishStatus);
}
/**
 * Safely refresh publish button/alert flags from BE.
 * - immediate: use after CRUD/publish/sort or once at end of a composite load flow
 * - default: debounced (coalesce rapid schedule data fetches e.g. search)
 */
export function refreshPublishStatusAfterCrud(commit, payload) {
    return __awaiter(this, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(payload.refreshPublishStatus !== false)) return [3 /*break*/, 2];
                    return [4 /*yield*/, refreshPublishStatusSafe(commit, payload.project_id, { immediate: true })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
export function refreshPublishStatusSafe(commit, projectId, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, Promise, function () {
        var _a, immediate, _b, debounceMs, error_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!projectId) {
                        return [2 /*return*/];
                    }
                    _a = options.immediate, immediate = _a === void 0 ? false : _a, _b = options.debounceMs, debounceMs = _b === void 0 ? DEFAULT_DEBOUNCE_MS : _b;
                    if (!immediate) return [3 /*break*/, 5];
                    if (debounceTimer) {
                        clearTimeout(debounceTimer);
                        debounceTimer = null;
                        pendingProjectId = null;
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetchAndCommitPublishStatus(commit, projectId)];
                case 2:
                    _c.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _c.sent();
                    console.warn('Failed to fetch publish status', error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
                case 5:
                    pendingProjectId = projectId;
                    if (debounceTimer) {
                        clearTimeout(debounceTimer);
                    }
                    debounceTimer = setTimeout(function () {
                        debounceTimer = null;
                        var id = pendingProjectId;
                        pendingProjectId = null;
                        if (!id) {
                            return;
                        }
                        fetchAndCommitPublishStatus(commit, id).catch(function (error) {
                            console.warn('Failed to fetch publish status', error);
                        });
                    }, debounceMs);
                    return [2 /*return*/];
            }
        });
    });
}
